var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationmarktrianglefill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -70.4590 96.1900 70.4590",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 1.12305L77.4414 1.12305C84.2285 1.12305 88.3789-3.61328 88.3789-9.81445C88.3789-11.6211 87.8418-13.5254 86.8652-15.2344L57.4707-66.2598C55.3711-69.873 51.8066-71.7773 48.0957-71.7773C44.3848-71.7773 40.7715-69.873 38.7207-66.2598L9.32617-15.2344C8.30078-13.4766 7.8125-11.6211 7.8125-9.81445C7.8125-3.61328 11.9629 1.12305 18.75 1.12305Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0957-24.6094C45.8496-24.6094 44.5801-25.8789 44.5312-28.125L43.9941-48.9258C43.9453-51.2207 45.6543-52.832 48.0469-52.832C50.3906-52.832 52.1973-51.1719 52.1484-48.877L51.5137-28.125C51.4648-25.8301 50.2441-24.6094 48.0957-24.6094ZM48.0957-11.377C45.6055-11.377 43.4082-13.3301 43.4082-15.8203C43.4082-18.3105 45.5566-20.3125 48.0957-20.3125C50.5859-20.3125 52.7344-18.3105 52.7344-15.8203C52.7344-13.2812 50.5859-11.377 48.0957-11.377Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationmarktrianglefill);
export default __webpack_public_path__ + "static/media/exclamationmark.triangle.fill.4fcb6955499f8a13713b9bdae5db3e99.svg";
export { ForwardRef as ReactComponent };